import {
  EstateApplication,
  UserId,
  EstateId,
  ApplicationId,
} from '../../../domain';
import { EstateApplicationDTO } from '../dtos';

export const mapExposedEstateApplicationDtoToDomain = (
  estateApplicationDto: EstateApplicationDTO
) => {
  return new EstateApplication(
    new ApplicationId(estateApplicationDto.id),
    new UserId(estateApplicationDto.tenantUserId),
    new EstateId(estateApplicationDto.estate.id),
    estateApplicationDto.stage,
    estateApplicationDto.source
  );
};
